import { useState, type FormEvent } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button, Field } from '@mailflow/ui';
import { useLogin } from '../lib/auth.js';
import { ApiRequestError } from '../lib/api.js';

export function LoginPage() {
  const navigate = useNavigate();
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const error = login.error;
  const fieldErrors = error instanceof ApiRequestError ? (error.fields ?? {}) : {};
  const generalError =
    error instanceof ApiRequestError && Object.keys(fieldErrors).length === 0
      ? error.message
      : error && !(error instanceof ApiRequestError)
        ? 'Unerwarteter Fehler bei der Anmeldung.'
        : null;

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    try {
      await login.mutateAsync({ email, password });
      await navigate({ to: '/' });
    } catch {
      // Der Fehler steht bereits in login.error und wird unten angezeigt.
    }
  }

  return (
    <main className="auth-layout">
      <div className="card auth-card">
        <div className="card__body stack">
          <header className="stack" style={{ gap: 'var(--space-1)' }}>
            <h1 style={{ fontSize: 'var(--text-xl)' }}>Anmelden</h1>
            <p className="muted text-sm">MailFlow — Marketing-Automation und CRM</p>
          </header>

          {generalError && (
            <div className="alert" data-tone="danger" role="alert">
              {generalError}
            </div>
          )}

          <form className="stack" onSubmit={handleSubmit} noValidate>
            <Field
              label="E-Mail-Adresse"
              type="email"
              name="email"
              autoComplete="username"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              {...(fieldErrors.email ? { error: fieldErrors.email } : {})}
            />

            <Field
              label="Passwort"
              type="password"
              name="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              {...(fieldErrors.password ? { error: fieldErrors.password } : {})}
            />

            <Button type="submit" fullWidth loading={login.isPending}>
              {login.isPending ? 'Wird geprueft...' : 'Anmelden'}
            </Button>
          </form>
        </div>
      </div>
    </main>
  );
}
